
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { loginUserAPI } from "../Services/Services";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ userType, email, password }, { rejectWithValue }) => {
    try {
      const data = await loginUserAPI(userType, email, password);
      const token = data.access_token;    //to store the access token 
      const decoded = jwtDecode(token);  // to decode the admin i dor manager id 

      const role = userType === "manager" ? "manager" : "admin";

      return {
        token,
        email: decoded.email || email,
        userId: data.admin_id || data.manager_id || decoded.sub || null,
        adminId: data.admin_id || null,
        managerId: data.manager_id || null,
        role, 
      };
    } catch (err) {
      console.error("Login error:", err);
      return rejectWithValue(err?.detail || "Login failed");
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    email: null,
    userId: null,
    adminId: null,
    managerId: null,
    role: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.token = null;
      state.email = null;
      state.userId = null;
      state.adminId = null;
      state.managerId = null;
      state.role = null; 
      localStorage.removeItem("auth");
    },
    loadStoredAuth: (state) => {
      const stored = localStorage.getItem("auth");
      if (stored) Object.assign(state, JSON.parse(stored));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        Object.assign(state, action.payload);
        localStorage.setItem("auth", JSON.stringify(action.payload));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, loadStoredAuth } = authSlice.actions;
export default authSlice.reducer;
